import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";

import { inject } from "@angular/core";

import { catchError, throwError } from "rxjs";
import { ToastServicee } from "../shared/toast.service";

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastServicee);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error("Global API Error:", error);

      let errorMessage = "Something went wrong";

      // Server is reachable but returns error
      if (error.status >= 500) {
        errorMessage =
          getServerErrorMessage(error) ||
          "Internal server error. Please try again later.";
      }

      // Unauthorized
      else if (error.status === 401) {
        errorMessage =
          getServerErrorMessage(error) ||
          "Session expired. Please login again.";
      }

      // Forbidden
      else if (error.status === 403) {
        errorMessage =
          getServerErrorMessage(error) ||
          "You do not have permission to perform this action.";
      }

      // Not found
      else if (error.status === 404) {
        errorMessage =
          getServerErrorMessage(error) || "Requested data was not found.";
      }

      // Bad request
      else if (error.status === 400) {
        errorMessage = getServerErrorMessage(error) || "Invalid request.";
      }

      // Network error
      else if (error.status === 0) {
        errorMessage =
          "Unable to connect to server. Please check your internet connection.";
      }

      // Other errors
      else {
        errorMessage = getServerErrorMessage(error) || "Something went wrong.";
      }

      // Show toast globally
      toastService.error(errorMessage);

      // Important: Send error back to component
      return throwError(() => error);
    }),
  );
};

/**
 * Extract server error message
 */
function getServerErrorMessage(error: HttpErrorResponse): string | null {
  const body = error.error;
  console.log("Server error body:", error);

  if (!body) {
    return null;
  }

  // Example:
  // { message: "Tenant not found" }

  if (typeof body === "object") {
    console.log("Server error body:", body);
    return (
      body.errorMessage ||
      body.message ||
      body.error ||
      body.detail ||
      body.title ||
      null
    );
  }

  // Example:
  // "Internal server error"

  if (typeof body === "string") {
    return body;
  }

  return null;
}
